import { useFormik } from 'formik';
import React, { useCallback, useContext, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { ConfirmContext } from '../../contexts/confirm.context';
import { IBarComposer } from '../../models/IBars';
import ManageBarPage from '../../pages/ManageBar/ManageBar.page';
import BarsService from '../../services/bar/bar.service';
import { LocationOption } from '../../services/location/location.service';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
    name: yup.string().required(),
    address: yup.string().required(),
    // image: yup.object().required(),
    pocName: yup.string().required(),
    pocAddress: yup.string().required(),
    pocEmail: yup.string().required(),
    pocRole: yup.string().required(),
    pocPhone: yup.string().required()
})


export default function ManageBarContainer(props) {


    const params = useParams<any>();
    const history = useHistory()
    const { show } = useContext(ConfirmContext);

    const formik = useFormik({
        initialValues: {
            name: '',
            address: '',
            lat: undefined,
            lng: undefined,
            rewards: '',
            image: null,
            pocName: "",
            pocAddress: "",
            pocEmail: "",
            pocRole: "",
            pocPhone: '',
            merchantName: ''
        },
        validationSchema,
        onSubmit: async ({
            name,
            address,
            lat,
            lng,
            rewards,
            image,
            pocName,
            pocAddress,
            pocEmail,
            pocRole,
            pocPhone,
            merchantName
        }) => {

            const composer: IBarComposer = {
                name,
                address,
                lat,
                lng,
                rewards,
                image,
                merchantName,
                poc: {
                    name: pocName,
                    email: pocEmail,
                    address: pocAddress,
                    role: pocRole,
                    phone: pocPhone
                }
            }

            try {
                if (params.id) {
                    await BarsService.updateBar(params.id, composer);
                    history.replace(`/bar-details/${params.id}`)
                } else {
                    const createdBar = await BarsService.createBar(composer);

                    if (createdBar?.id) {
                        history.replace(`/bar-details/${createdBar.id}`);
                    } else {
                        history.replace("/dashboard?view=bars");
                    }
                }
            } catch (error) {
                const message = error?.message || "The bar could not be saved. Please try again.";
                show({
                    title: "Unable to save bar",
                    message,
                    actions: [
                        {
                            title: "OK",
                            role: "cancel",
                            style: { color: "#fff" }
                        }
                    ]
                });
            }

        }
    })


    useEffect(() => {
        if (params.id) {
            BarsService.getBar(params.id).then(({
                name,
                address,
                image,
                merchantName,
                rewards,
                rewardsSummary,
                lat,
                lng,
                poc: {
                    name: pocName,
                    address: pocAddress,
                    email: pocEmail,
                    role: pocRole,
                    phone: pocPhone
                }
            }) => {
                formik.setValues({
                    name,
                    address,
                    lat,
                    lng,
                    image,
                    pocName,
                    pocAddress,
                    pocEmail,
                    pocRole,
                    pocPhone,
                    merchantName: merchantName || "",
                    rewards: rewards || rewardsSummary || ""
                })
            })
        }

    }, [params?.id])

    const isTouched = useCallback((field) => !!formik.touched[field], [formik.touched])
    const getError = useCallback((field) => isTouched(field) ? formik.errors[field] || "" : "", [formik.errors, isTouched]);

    const onHandleChange = (key: string) => (value) => {
        formik.setFieldTouched(key);
        if (key === "address") {
            formik.setFieldValue("lat", undefined);
            formik.setFieldValue("lng", undefined);
        }
        formik.setFieldValue(key, value);
    }

    const onBarLocationSelect = useCallback((location: LocationOption) => {
        formik.setFieldTouched("address");
        formik.setFieldValue("address", location.address);
        formik.setFieldValue("lat", location.lat);
        formik.setFieldValue("lng", location.lng);
    }, [formik]);

    const onPocAddressLocationSelect = useCallback((location: LocationOption) => {
        formik.setFieldTouched("pocAddress");
        formik.setFieldValue("pocAddress", location.address);
    }, [formik]);


    console.log("the data ", formik.errors, formik.touched, formik.values)


    return (
        <ManageBarPage
            data={formik.values}
            onHandleChange={onHandleChange}
            onBarLocationSelect={onBarLocationSelect}
            onPocAddressLocationSelect={onPocAddressLocationSelect}
            onSavePress={formik.handleSubmit}
            valid={formik.isValid && formik.dirty && formik.values.image}
        />
    )
}
